import styles from './announcementBar.module.scss';

import React, { useMemo } from 'react';

import adler32 from 'adler-32';
import { onlyText } from 'react-children-utilities';


import { useSessionStorage } from '../../../utils/useLocalStorage';
import { LocalizedLink } from '../../primitives';

export default function AnnouncementBar(props: any) {
    const messageSignature = useMemo(
        () => adler32.str(onlyText(props.children)).toString(16),
        [props.children]
    );
    const [messageDismissed, setMessageDismissed] = useSessionStorage(
        'annoucementDismissed:' + messageSignature,
        false
    );

    return (
        <>
            {!messageDismissed && (
                <div className={styles.announceBarWrap}>
                    <div className={styles.announceBarChild}>
                        {props.children}
                    </div>
                    {props.ctaText && props.ctaLink && (
                        <>
                            &nbsp;
                            <LocalizedLink to={props.ctaLink}>
                                {props.ctaText}
                            </LocalizedLink>
                        </>
                    )}
                    <div
                        className={styles.close}
                        onClick={() => setMessageDismissed(true)}
                    />
                </div>
            )}
        </>
    );
}
